import { render, staticRenderFns } from "./BulkUnmappingConfirm.vue?vue&type=template&id=7861e670&scoped=true"
import script from "./BulkUnmappingConfirm.vue?vue&type=script&lang=js"
export * from "./BulkUnmappingConfirm.vue?vue&type=script&lang=js"
import style0 from "./BulkUnmappingConfirm.vue?vue&type=style&index=0&id=7861e670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7861e670",
  null
  
)

export default component.exports